const state = {
  regionList: [
    {
      name: "Hà Nội",
      code: "hn",
      short_name: "HaNoi",
    },
    {
      name: "Hồ Chí Minh",
      code: "hcm",
      short_name: "HoChiMinh",
    },
  ],
  currentRegion: "",
  currentEnvironment: "",
  config: "",
};

const getters = {
  regionList: () => {
    return state.regionList?.map((region) => {
      return {
        name: region?.name,
        code: region?.code?.toLocaleLowerCase(),
        short_name: region?.short_name,
      };
    });
  },
  currentRegion: (state) => {
    return state.currentRegion;
  },
  currentEnvironment: (state) => {
    return state.currentEnvironment;
  },
  config: (state) => {
    return state.config;
  },
};

const mutations = {
  UPDATE_CONFIG_ENDPOINT(state, payload) {
    state.currentRegion = payload.currentRegion;
    state.currentEnvironment = payload.currentEnvironment;
    state.config = payload.config;
    state.regionList = payload.regionList;
  },
};

const actions = {
  updateConfigEndpoint({ commit }, payload) {
    commit("UPDATE_CONFIG_ENDPOINT", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
